/**
 * 起動時の配線。顧客向けと同じ認証部品（共通パッケージ）を使う。
 * モックは顧客向けアプリ側にしか置かない（オペレーター向けはまだ画面が無い）。
 */

import {
  AdminSession,
  createAdminClient,
  readAdminAuthConfig,
} from "visumo-data-agent-web-shared";
import type { Client } from "urql";

export type Bootstrap =
  | { ok: true; session: AdminSession; client: Client }
  | { ok: false; missing: string[] };

export function bootstrap(): Bootstrap {
  const env = import.meta.env as unknown as Record<
    string,
    string | boolean | undefined
  >;
  const configResult = readAdminAuthConfig(env, {
    // オペレーター向けは別のスコープを要求する。顧客向けの成果物と
    // 権限の範囲を分けるため、既定値もアプリごとに持つ
    defaultScope: "admin-operator",
    defaultClientName: "visumo 管理画面(オペレーター向け)",
  });
  if (!configResult.ok) {
    return { ok: false, missing: configResult.missing };
  }
  const session = new AdminSession({ config: configResult.config });
  return { ok: true, session, client: createAdminClient({ session }) };
}
